let offsetMs = 0;
let generation = 0;

export const syncServerClock = (serverNowIso: string | undefined, requestStartedAt = Date.now()): void => {
  if (!serverNowIso) return;
  const server = Date.parse(serverNowIso);
  if (Number.isNaN(server)) return;
  offsetMs = server - (requestStartedAt + Date.now()) / 2;
  generation += 1;
};

export const isClockSynced = (): boolean => generation > 0;

export const clockGeneration = (): number => generation;

export const serverNow = (): number => Date.now() + offsetMs;
